import { useTranslation } from 'react-i18next';
import { CardExpirationBanner } from '@/common/components/CardExpirationBanner/CardExpirationBanner';
import { LoadingPlaceholder } from '@/common/components/LoadingPlaceholder/LoadingPlaceholder';
import { PageLayout } from '@/common/components/PageLayout/PageLayout';
import { Stack } from '@/common/components/Stack/Stack';
import { ROUTES } from '@/common/constants/routes';
import { CardActions } from '@/common/containers/Dashboard/Profile/CardDetailsPage/components/CardActions/CardActions';
import { CardPreview } from '@/common/containers/Dashboard/Profile/CardDetailsPage/components/CardActions/components/CardPreview/CardPreview';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { useGetCardsData } from '@/common/integrations/menhir/employee/card/card.hooks';
import { usePageViewTracking } from '@/web/hooks/usePageViewTracking';
import { Redirect, useLocalSearchParams } from 'expo-router';

export const CardDetailPage = () => {
  usePageViewTracking('card_page');
  const { t } = useTranslation();

  const searchParams = useLocalSearchParams<{
    cardId?: string;
  }>();
  const { cards, isInitialLoading: loadingCards } = useGetCardsData();
  const { company } = useEmployeeDetails();

  if (loadingCards || (!loadingCards && (!cards || !cards?.length))) {
    return <LoadingPlaceholder />;
  }

  if (!cards || !cards.length) {
    return <Redirect href={ROUTES.ROOT} />;
  }

  const cardToDisplay =
    cards.find((card) => card.id === searchParams.cardId) || cards[0];

  const isDigitalUnblocked =
    cardToDisplay.format === 'digital' && cardToDisplay.status === 'active';

  return (
    <PageLayout
      headerProps={{
        title: t('dashboard.card.title'),
        description:
          cardToDisplay.status !== 'expired' && isDigitalUnblocked
            ? t('dashboard.card.description.digital')
            : t(`dashboard.card.description.${cardToDisplay.status}`),
        backButton: true,
      }}
    >
      {cardToDisplay.status === 'expired' && cards.length === 1 ? (
        <CardExpirationBanner
          isExpired
          isDigitalRequestFormatRenewal={
            company.settings.cardRequestFormat === 'digital'
          }
        />
      ) : null}
      <Stack gap="xl">
        <CardPreview card={cardToDisplay} />
        <CardActions card={cardToDisplay} />
      </Stack>
    </PageLayout>
  );
};
